import { Link } from "react-router-dom";
import WhatsAppWidget from "./WhatsAppWidget";

export default function FloatingCTA() {
  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2.5">
      {/* Call Now */}
      <a
        href="tel:+919999365655"
        className="flex items-center gap-2 bg-white text-slate-800 px-4 py-2.5 rounded-full shadow-lg border border-slate-100 hover:shadow-xl transition-all hover:scale-105 group"
        title="Call Now"
      >
        <span className="w-9 h-9 rounded-full bg-cta-500 flex items-center justify-center shrink-0">
          <i className="ri-phone-line text-white text-base"></i>
        </span>
        <span className="text-sm font-semibold hidden sm:block group-hover:text-cta-600 transition-colors whitespace-nowrap">
          +91 99993 65655
        </span>
      </a>

      {/* WhatsApp — Context Aware */}
      <WhatsAppWidget variant="floating" />

      {/* Book Consultation */}
      <Link
        to="/book-appointment?source=Homepage"
        className="flex items-center gap-2 bg-primary-600 text-white px-4 py-2.5 rounded-full shadow-lg hover:bg-primary-700 hover:shadow-xl transition-all hover:scale-105 group"
        title="Book Free Consultation"
      >
        <span className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center shrink-0">
          <i className="ri-calendar-check-line text-white text-base"></i>
        </span>
        <span className="text-sm font-semibold hidden sm:block whitespace-nowrap">
          Book Free Consultation
        </span>
      </Link>

      {/* Get Quote */}
      <Link
        to="/compare-plans"
        className="flex items-center gap-2 bg-amber-500 text-white px-4 py-2.5 rounded-full shadow-lg hover:bg-amber-600 hover:shadow-xl transition-all hover:scale-105 group"
        title="Get Quote"
      >
        <span className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center shrink-0">
          <i className="ri-calculator-line text-white text-base"></i>
        </span>
        <span className="text-sm font-semibold hidden sm:block whitespace-nowrap">
          Get Quote
        </span>
      </Link>
    </div>
  );
}